import { Stack } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useState } from "react";
import Commands from "../../commands";
import NullCheck from "components/NullCheck";
import ShowFault from "../ShowFault";
import McBoostPower from "../../commands/McBoostPower";
import Details from "./Details";
import McInfo from "../McInfo";
import { MC_SOFTWARE_TYPE } from 'config/const';
import B22MonitoringCard from 'containers/microControllers/b22/MonitoringCard';
import Tables from './Tables';
import { useDispatch, useSelector } from 'react-redux';
import { setShowMassage } from 'store/sysSlice';
import { ROLES_ID } from 'config/roles';
import { supportsCommands } from './tableData';

const GroupData = ({ list: sourceList, displayType = 'cards' }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.userSettings?.user);
  const userRole = user?.userRole;
  const assigned = user?.department?.mcList;
  const restricted = [ROLES_ID.DEPARTMENT_MANAGER, ROLES_ID.EMPLOYEE].includes(userRole) && assigned?.length > 0;
  const list = restricted ? sourceList.filter(mc => assigned.some(id => String(id) === String(mc.parentId || mc.id))) : sourceList;
  const { bt } = useBizTypeTranslation();
  const [mcGuidCommand, setMcGuidCommand] = useState(null)
  const [faultData, setFaultData] = useState(null)
  const [openBoostPower, setOpenBoostPower] = useState(false)
  const [mcDropList, setMcDropList] = useState([])
  const [mcGuidInfo, setMcGuidInfo] = useState(null)
  const commandController = list.find(mc => mc.guid === mcGuidCommand);
  const infoController = list.find(mc => mc.guid === mcGuidInfo);
  const openCommand = guid => {
    const mc = list.find(item => item.guid === guid);
    if (!mc || !supportsCommands(mc)) return;
    if (!mc.isConnected) dispatch(setShowMassage({ massage: 'ERROR_MC_NOT_CONNECTED', type: 'error' }));
    else setMcGuidCommand(guid);
  };
  const openInfo = guid => {
    if (userRole === ROLES_ID.SU_ADMIN && list.some(mc => mc.guid === guid && !mc.isB22Sensor)) setMcGuidInfo(guid);
  };

  const onClickMcDrop = (mc) => {
    if (mcDropList.includes(mc?.id))
      setMcDropList(prav => prav.filter(i => i !== mc?.id))
    else
      setMcDropList(prav => ([...prav, mc?.id]))
  }

  return (
    <Stack
      width="100%"
      spacing={2}
      direction="row"
      useFlexGap
      flexWrap="wrap"
      overflow="auto"
      pb={8}
      pt={{ xs: 1, md: 0 }}
      px={2}
    >
      {displayType === 'table' ? <Tables list={list} onFault={setFaultData}
        onInfo={userRole === ROLES_ID.SU_ADMIN ? openInfo : undefined}
        onCommand={mc => openCommand(mc.guid)} /> : list?.map((mc, idx) => {
        if (mc.softwareType === MC_SOFTWARE_TYPE.B2_2) return (
          <B22MonitoringCard key={mc.id} mc={mc} expanded={mcDropList.includes(mc.id)}
            onToggle={() => onClickMcDrop(mc)} onFault={setFaultData} />
        );
        return (
          <Details
            key={idx}
            mc={mc}
            mcDropList={mcDropList}
            onClickMcDrop={onClickMcDrop}
            setFaultData={setFaultData}
            setMcGuidCommand={openCommand}
            setMcGuidInfo={openInfo}
          />
        );
      })}

      <NullCheck valueForCheck={commandController && supportsCommands(commandController) && commandController.isConnected}>
        <Commands
          mcGuid={mcGuidCommand}
          setMcGuid={setMcGuidCommand}
          setOpenBoostPower={setOpenBoostPower}
        />
      </NullCheck>

      <NullCheck valueForCheck={faultData}>
        <ShowFault
          data={faultData}
          setData={setFaultData}
        />
      </NullCheck>

      <NullCheck valueForCheck={openBoostPower && list.some(mc => mc.guid === openBoostPower?.data?.guid && supportsCommands(mc) && mc.isConnected)}>
        <McBoostPower
          data={openBoostPower}
          setData={setOpenBoostPower}
        />
      </NullCheck>

      <NullCheck valueForCheck={infoController && !infoController.isB22Sensor && userRole === ROLES_ID.SU_ADMIN}>
        <McInfo
          mcGuid={mcGuidInfo}
          setMcGuid={setMcGuidInfo}
          list={list}
        />
      </NullCheck>

    </Stack>
  );
};
export default GroupData;
